export const SET_AVAILABILITY_PAGE_LOADING = 'availability/SET_AVAILABILITY_PAGE_LOADING'
export const SET_AVAILABILITY_PAGE_ERROR = 'availability/SET_AVAILABILITY_PAGE_ERROR'

export const CLEAR_AVAILABILITY_LIST = 'availability/CLEAR_AVAILABILITY_LIST'

export const GET_AVAILABILITY_LIST = 'availability/GET_AVAILABILITY_LIST'
export const GET_AVAILABILITY_LIST_SUCCESS = 'availability/GET_AVAILABILITY_LIST_SUCCESS'
export const GET_AVAILABILITY_LIST_RESET_SUCCESS = 'availability/GET_AVAILABILITY_LIST_RESET_SUCCESS'
export const GET_AVAILABILITY_LIST_ERROR = 'availability/GET_AVAILABILITY_LIST_ERROR'

export const GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION = 'availability/GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION'
export const GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION_SUCCESS =
  'availability/GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION_SUCCESS'
export const GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION_ERROR =
  'availability/GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION_ERROR'
